import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class PenaliteDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"PENALITE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "PENALITE",
            penaliter: event.detail?.penaliter,
            penalitySucced: event.detail?.penalitySucced ?? true,
          };
    }

    get penaliter() {
        return this.detail.penaliter;
    }
    set penaliter(value) {
        this.detail.penaliter = value;
    }

    get penalitySucced() {
        return this.detail.penalitySucced;
    }

    set penalitySucced(value) {
        this.detail.penalitySucced = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "penaliter", "penalitySucced"].includes(key)){
            let commentaire = "Penalité"

            const penaliterPlayer = getPlayer(this.penaliter, match)
            const team = getTeam(this.team, match)

            if(this.penaliter){
                if(penaliterPlayer){
                    commentaire += ' de '+ penaliterPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(!this.penalitySucced)
                 commentaire += "Malheureusement la pénalité est manquée."

            this.text = commentaire
        }
    }
}